/**
 * AMAÇ: Trusted Types 'default' policy — CSP'ye require-trusted-types-for 'script'
 * eklendiğinde, açıkça bir policy kullanmayan kod (sweetalert2'nin dahili innerHTML
 * ataması, kendi script.src atamalarımız — GoogleLoginButton/googleAnalytics.js —, Vite'ın
 * React.lazy() chunk'ları için dinamik <script> oluşturması) TypeError fırlatıp
 * kırılmasın diye tarayıcının otomatik başvuracağı, geçirgen (passthrough) "default"
 * policy'yi tanımlar. Sanitizasyon yapmıyor — amaç XSS filtrelemek değil, açıkça
 * kötü niyetli bir 3. parti script'in KENDİ policy'sini enjekte edip TT korumasını
 * bypass etmesini engellemek (CSP'deki "trusted-types default" bunu zaten kısıtlıyor).
 *
 * main.jsx'te İLK import olmalı — policy, herhangi bir sink'e dokunulmadan ÖNCE
 * kayıtlı olmalı. Trusted Types'ı desteklemeyen tarayıcılarda (Firefox/Safari)
 * window.trustedTypes tanımsızdır; CSP direktifi de bu tarayıcılarca yok sayılır.
 */
if (window.trustedTypes?.createPolicy) {
  window.trustedTypes.createPolicy('default', {
    createHTML: (s) => s,
    createScript: (s) => s,
    createScriptURL: (s) => s,
  });
}
